import styled from 'styled-components';

const Container = styled.div`
    width: 100%;
    gap: 2rem;
    display: grid;
`;

export default Container;